var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgCrossIcon = function SvgCrossIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.852 6.074l.265-.265-.265-.265-.393-.393-.265-.265-.265.265L12 11.078 6.074 5.151l-.265-.265-.265.265-.393.393-.265.265.265.265 5.927 5.927-5.927 5.928-.265.265.265.265.393.393.265.265.265-.265 5.927-5.928 5.928 5.928.265.265.265-.265.393-.393.265-.265-.265-.265L12.924 12l5.928-5.927z",
    fill: "#222",
    stroke: "#222",
    strokeWidth: 0.75
  })));
};
export default SvgCrossIcon;